import { setLoading, setTasks, setTask, taskCreated, taskUpdated, taskDeleted, setError } from "../slices/task"
import axios from "axios"

const getAuthToken = () => {
  try {
    const raw = localStorage.getItem("userInfo")
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed?.token || null
  } catch (e) {
    return null
  }
}

export const getTasks = () => async dispatch => {
  dispatch(setLoading())
  try {
    const token = getAuthToken()
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {}
    const { data } = await axios.get("/api/tasks", config)
    dispatch(setTasks(data))
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred loading tasks. Please try again later"
      )
    )
  }
}

export const getTask = id => async dispatch => {
  dispatch(setLoading())
  try {
    const token = getAuthToken()
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {}
    const { data } = await axios.get(`/api/tasks/${id}`, config)
    dispatch(setTask(data))
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred loading task. Please try again later"
      )
    )
  }
}

export const createTask = taskData => async dispatch => {
  dispatch(setLoading())
  try {
    const token = getAuthToken()
    const config = token
      ? { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
      : { headers: { "Content-Type": "application/json" } }
    const { data } = await axios.post("/api/tasks", taskData, config)
    dispatch(taskCreated(data))
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred creating task. Please try again later"
      )
    )
    throw error
  }
}

export const updateTask = (id, taskData) => async dispatch => {
  dispatch(setLoading())
  try {
    const token = getAuthToken()
    const config = token
      ? { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
      : { headers: { "Content-Type": "application/json" } }
    const { data } = await axios.put(`/api/tasks/${id}`, taskData, config)
    dispatch(taskUpdated(data))
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred updating task. Please try again later"
      )
    )
    throw error
  }
}

export const deleteTask = id => async dispatch => {
  dispatch(setLoading())
  try {
    const token = getAuthToken()
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {}
    await axios.delete(`/api/tasks/${id}`, config)
    dispatch(taskDeleted(id))
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred deleting task. Please try again later"
      )
    )
    throw error
  }
}
